<script>
import dialog2Mixin from "../mixins/dialog2";
import { merchantComputed } from '@store/helpers'
import VueQr from 'vue-qr'

export default {
  components: {
    VueQr
  },
  mixins: [dialog2Mixin],
  data() {
    return {
      config: {
        value: this.lineFriendUrl,
        imagePath: window.globalData.imagePath,
        filter: 'color', // threshold or color
      },
      storeTitle: '',
      lineId: '',
      lineFriendUrl: ''
    }
  },
  computed: {
    ...merchantComputed,
    formatLineId() {
      return this.lineId.replace('@', '')
    },
  },
  mounted() {
    const initConfigImagePath = () => {
      console.log(this.currentMerchant.logo)
      let imageURL = this.currentMerchant.logo;
      if (!imageURL) {
        imageURL = this.$globalIsDingBeauty ? require('@assets/images/default/logo-default_ding.svg') : require('@assets/images/default/logo-default.svg')
      }
      const newImg = new Image;

      const imageReceived = () => {
        let canvas = document.createElement("canvas");
        let context = canvas.getContext("2d");

        const params = () => {
          const isWidthBigThanHeight = newImg.width > newImg.height;
          const isHeightBigThanWidth = newImg.height > newImg.width;
          const isHeightSameWidth = newImg.height === newImg.width;

          const { width: widthn, height: heightn } = newImg;

          if(isWidthBigThanHeight) {
            return {
              width: widthn,
              height: widthn,
              dx: 0,
              dy: (newImg.width / 2) - (newImg.height / 2)
            }
          }

          if(isHeightBigThanWidth) {
            return {
              width: heightn,
              height: heightn,
              dx: (newImg.height / 2) - (newImg.width / 2),
              dy: 0
            }
          }

          if(isHeightSameWidth) {
            return {
              width: newImg.width,
              height: newImg.height,
              dx: 0,
              dy: 0
            }
          }
        };

        canvas.width = params().width;
        canvas.height = params().height;

        context.drawImage(newImg, params().dx, params().dy);

        this.config.imagePath = canvas.toDataURL();
      };

      const imageError = () => {
        this.config.imagePath = '';
      };

      newImg.crossOrigin = "Anonymous";
      newImg.src = imageURL;
      newImg.addEventListener("load", imageReceived, false);
      newImg.addEventListener("error", imageError, false);
    };

    initConfigImagePath()
  },
}
</script>
<!-- section template -->
<template>
  <el-dialog
    :visible.sync="dialog2MixinVisible"
    :custom-class="`${ $style.dialogLine } isStyleBase text-center`"
    width="582px"
    append-to-body
    @closed="$Dialog2MixinOnDestroy"
  >
    <div ref="addImage"></div>
    <div class="dialogLine__title">
      <span>立即加入</span>
      <div class="d-flex justify-content-center flex-wrap">
        <span>{{ currentMerchant.title }}</span>
        <span v-if="storeTitle" class="mr-3"> {{ storeTitle }} </span>
        <span>LINE官方好友</span>
      </div>
    </div>
    <div
      v-if="lineFriendUrl"
      class="dialogLine__qrcodeBox"
    >
      <VueQr
        v-if="lineFriendUrl"
        class="dialogLine__qrcode"
        :logo-src="`${ config.imagePath }`"
        :text="lineFriendUrl"
        :size="180"
        :logo-margin="3"
        :logo-scale="0.3"
        :logo-corner-radius="0"
        :margin="0"
        :correct-level="3"
      />
    </div>
    <div class="dialogLine__description">
      <span v-if="lineFriendUrl">掃描上方QRcode</span>
      <br v-if="lineFriendUrl && lineId"><span v-if="lineId && lineFriendUrl">或</span> <span
      v-if="lineId">搜尋LINE ID:@{{ formatLineId }}</span>
      <br>即可加入好友，享受更便利的寵物服務！
    </div>
    <BaseButton
      class="isStylePrimary isRadius isFull"
      @click="dialog2MixinVisible = false"
    >
      關閉視窗
    </BaseButton>
  </el-dialog>
</template>
<!-- section style -->
<style lang="scss" module>
.dialogLine {
  :global {
    .dialogLine {
      &__title {
        margin-bottom: 2.5rem;
        font-size: 1.5rem;
        font-weight: 600;
        line-height: 1.5;
      }

      &__qrcodeBox {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 195px;
        height: 195px;
        margin: 0 auto 2rem;
        background: darken(#FFF, 1%);
      }

      &__qrcode {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        width: 100%;
        user-select: none;
      }

      &__description {
        margin-bottom: 2.5rem;
        font-size: 0.875rem;
        line-height: 1.75;
        color: $color-gray-2;
      }
    }
  }
}
</style>
